import { createNamespacedHelpers, mapActions } from 'vuex'
const accountAttributeController = createNamespacedHelpers('account_attribute')
const userAttributeController = createNamespacedHelpers('user_attribute')

export default {
  data () {
    return {
      tributeOpts: {
        trigger: "{{",
        values: [],
        selectTemplate: function(item) {
          if (item && item.original && item.original.key) {
            return '{{' + item.original.key + '}}'
          }
        },
        menuItemTemplate: function(item) {
          return `<p class="mb-0">${item.original.key}</p><p class="mb-0 text-sm text-help">${item.original.value}</p>`;
        },
        requireLeadingSpace: false,
        selectClass: 'tribute-selected'
      }
    }
  },
  computed: {
    ...accountAttributeController.mapState({
      tribute_account_attributes: state => state.account_attributes
    }),
    ...userAttributeController.mapState({
      tribute_user_attributes: state => state.user_attributes
    }),
    Variables () {
      try {
        return this.tribute_account_attributes.concat(this.tribute_user_attributes).filter(a => a.name).map(a => { return { key: a.name, value: a.description } })
      } catch (e) {
        return []
      }
    }
  },
  mounted () {
    this.tributeOpts.values = this.Variables.slice()
  },
  watch: {
    Variables (value = []) {
      this.tributeOpts.values = value.slice()
    }
  }
}
